import { render, staticRenderFns } from "./MyWishList.vue?vue&type=template&id=30d866ba&scoped=true"
import script from "./MyWishList.vue?vue&type=script&lang=js"
export * from "./MyWishList.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./MyWishList.vue?vue&type=style&index=0&id=30d866ba&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "30d866ba",
  "647b6042"
  
)

export default component.exports